import { storeData, getStoredData } from "./localStorage";
import type { Token } from "./definitions";

const PARTICIPANT_STORAGE_KEY = "TWILIO_WEBCHAT_PARTICIPANTS";
const TOKEN_STORAGE_KEY = "TWILIO_WEBCHAT_WIDGET";

type StoredParticipantNames = Record<string, string>;

export function clearStoredParticipantNames(): void {
    localStorage.removeItem(PARTICIPANT_STORAGE_KEY);
}

function isTokenValid(): boolean {
    const token = getStoredData<Token>(TOKEN_STORAGE_KEY);
    if (!token) {
        return false;
    }
    return Date.now() < token.expiration;
}

export function getStoredParticipantNames(): StoredParticipantNames {
    if (!isTokenValid()) {
        clearStoredParticipantNames();
        return {};
    }
    return getStoredData<StoredParticipantNames>(PARTICIPANT_STORAGE_KEY) ?? {};
}

export function storeParticipantName(
    identity: string | null | undefined,
    friendlyName: string | null | undefined
): void {
    if (!identity || !friendlyName) {
        return;
    }

    if (!isTokenValid()) {
        return;
    }

    const current = getStoredData<StoredParticipantNames>(PARTICIPANT_STORAGE_KEY) ?? {};
    if (current[identity] === friendlyName) {
        return;
    }
    current[identity] = friendlyName;
    storeData<StoredParticipantNames>(PARTICIPANT_STORAGE_KEY, current);
}
